/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2025 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

const XngLoadProducts: typeof LoadProducts = ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges")
        : (getProductCollectionParameter.expand = ["images", "badges"]);

    // XNG-Changed
    const shouldExcludeProductId = isRecentlyViewedOnPDP || isProductDetailsPage;
    (getProductCollectionParameter as any).excludeProductId = shouldExcludeProductId ? productId : undefined;

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            // XNG-Changed
            excludeProductId: shouldExcludeProductId ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
            additionalSort,
        }),
    );
};

replaceInChain(chain, LoadProducts, XngLoadProducts);
